import React from 'react'
import { Card, Tabs, message } from 'antd'
import { SettingOutlined, RocketOutlined, BgColorsOutlined, MessageOutlined } from '@ant-design/icons'
import { GeneralSettings } from '../components/GeneralSettings'
import { FeatureManagement } from '../components/FeatureManagement'
import { ThemeSettings } from '../components/ThemeSettings'
import { RadiusPricingTable } from '../components/RadiusPricingTable'
import { EnterpriseBillingSettings } from '../components/EnterpriseBillingSettings'
import { RFQSettings } from '../components/RFQSettings'
import { PaymentMethodSettings } from '../components/PaymentMethodSettings'
import { SmsSettings } from '../components/SmsSettings'
import { LegalSettings } from '../components/LegalSettings'
import { FileProtectOutlined, GlobalOutlined, SafetyCertificateOutlined, CreditCardOutlined, DollarOutlined } from '@ant-design/icons'

export const SettingsScreen: React.FC = () => {
    const handleSave = (values: any) => {
        console.log('Settings saved:', values)
        message.success('Settings saved successfully!')
    }

    const items = [
        {
            key: 'general',
            label: (
                <span>
                    <SettingOutlined />
                    General
                </span>
            ),
            children: <GeneralSettings onSave={handleSave} />,
        },
        {
            key: 'legal',
            label: (
                <span>
                    <FileProtectOutlined />
                    Legal & Policy
                </span>
            ),
            children: <LegalSettings />,
        },
        {
            key: 'enterprise-billing',
            label: (
                <span>
                    <DollarOutlined />
                    Enterprise Billing
                </span>
            ),
            children: <EnterpriseBillingSettings />,
        },
        {
            key: 'features',
            label: (
                <span>
                    <RocketOutlined />
                    Features
                </span>
            ),
            children: <FeatureManagement onSave={handleSave} />,
        },
        {
            key: 'theme',
            label: (
                <span>
                    <BgColorsOutlined />
                    Theme
                </span>
            ),
            children: <ThemeSettings onSave={() => message.success('Theme preferences saved!')} />,
        },
        {
            key: 'radius-pricing',
            label: (
                <span>
                    <GlobalOutlined />
                    Radius Pricing
                </span>
            ),
            children: <RadiusPricingTable />,
        },
        {
            key: 'rfq-global',
            label: (
                <span>
                    <SafetyCertificateOutlined />
                    Global Settings
                </span>
            ),
            children: <RFQSettings />,
        },
        {
            key: 'payment-methods',
            label: (
                <span>
                    <CreditCardOutlined />
                    Payment Methods
                </span>
            ),
            children: <PaymentMethodSettings />,
        },
        {
            key: 'sms-settings',
            label: (
                <span>
                    <MessageOutlined />
                    SMS Configuration
                </span>
            ),
            children: <SmsSettings />,
        },
    ]

    return (
        <Card>
            <Tabs defaultActiveKey="general" items={items} tabPosition="left" />
        </Card>
    )
}
